import type { StoreState, UiState } from '../state-types';

/** Update UI partially */
export const updateUi =
    (partialUi: Partial<UiState>) =>
    (state: StoreState): StoreState => ({
        ...state,
        ui: {
            ...state.ui,
            ...partialUi,
        },
    });
